<template>
    <div class="favorite-grid-skeleton-root">
        <FavoriteCardSkeleton v-for="i in count" :key="i" />
    </div>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Row from '~/components/skeletons/base/Row';
import Avatar from '~/components/skeletons/base/Avatar';
import FavoriteCardSkeleton from './FavoriteCardSkeleton';

export default {
    name: 'FavoriteGridSkeleton',
    components: { FavoriteCardSkeleton, Loading, Row, Avatar },
    props: {
        count: {
            type: Number,
            default: 6,
        },
    },
};
</script>

<style scoped>
.favorite-grid-skeleton-root {
    display: grid;

    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: var(--grid-gap);
}

@media only screen and (max-width: 600px) {
    .favorite-grid-skeleton-root {
        grid-template-columns: 1fr;
    }
}
</style>
